import { createFileRoute } from '@tanstack/react-router'
import EditionLinks from 'Edition/components/sections/Content/EditionLinks'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/content-links')({
    component: EditionLinks,
})
